<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Point</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Point</button>
		<button class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete Point</button>
	</div>
</div>

<!--Main Table-->
<div>
	<caass-auto-point-table [School]="School" (SelectedChanged)="OnSelectedChanged($event)"> </caass-auto-point-table>
</div>

<!--List of Schools Table-->
<div class="AccordianDiv TopMargin">
	<p-accordion>
		<p-accordionTab
			header="Schools {{ SelectedAutoPoint == null ? '(Select a Point)' : '(' + SelectedAutoPoint.SchoolCount + ')' }} {{
				SchoolExpand == true ? '(Click to Collapse)' : '(Click to Expand)'
			}}"
			[(selected)]="SchoolExpand"
		>
			<div>
				<caass-auto-point-school-table [SelectedAutoPoint]="SelectedAutoPoint"> </caass-auto-point-school-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
